import React, { useEffect } from 'react';
import { Hero } from './components/Hero';
import { ProofBar } from './components/ProofBar';
import { Situations } from './components/Situations';
import { Comparison } from './components/Comparison';
import { Gallery } from './components/Gallery';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { KitBonuses } from './components/KitBonuses';
import { Pricing } from './components/Pricing';
import { KitPricing } from './components/KitPricing';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
import { kitFaqs, kitFinalCta, kitHero, kitStats } from './data/kitOffer';
import { seo } from './data/content';
interface AppProps {
  /** "attuale" = live offer (100 mappe + 6 bonus). "kitProfessionali" = draft preview with the 6 new kits, keep off until the PDFs are ready. */
  offerVersion?: 'attuale' | 'kitProfessionali';
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  offerVersion = 'kitProfessionali',
  showTestimonials = false,
  showPurchaseNotifications = false
}: AppProps) {
  useMetaPixel();
  useEffect(() => {
    document.documentElement.lang = seo.lang;
    document.title = seo.title;
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = seo.description;
  }, []);
  const isKit = offerVersion === 'kitProfessionali';
  return <div className="w-full bg-white text-slate-900 antialiased" data-id="element-0" data-mp="nvarfq9f9dfl">
      <main data-id="element-1" data-mp="stubfl4ggf5b">
        {isKit ? <Hero subheadline={kitHero.subheadline} description={kitHero.description} data-id="element-2" data-mp="sssrss9dikbz" /> : <Hero data-id="element-3" data-mp="34ncnvv5d5yq" />}
        {isKit ? <ProofBar stats={kitStats} data-id="element-4" data-mp="3ud1g7bihxsbo" /> : <ProofBar data-id="element-5" data-mp="3ubrhck3tkg3z" />}
        <Situations data-id="element-6" data-mp="3uc9inv5c9kir" />
        <Comparison data-id="element-7" data-mp="3uf5ixq4nslad" />
        <Gallery data-id="element-8" data-mp="d4e75xjpjkyt" />
        <WhatYouGet data-id="element-9" data-mp="d4xopd5g47cb" />
        {isKit ? <KitBonuses data-id="element-10" data-mp="d45ti3frgbmk" /> : <Bonuses data-id="element-11" data-mp="d2l936n5u92f" />}
        {isKit ? <KitPricing data-id="element-12" data-mp="85uj9rljzz3t" /> : <Pricing data-id="element-13" data-mp="851hl51gbzsj" />}
        <Guarantee data-id="element-14" data-mp="86w6svjrae2f" />
        {showTestimonials && <Testimonials data-id="element-15" data-mp="83qhbf77ta66" />}
        {isKit ? <Faq faqs={kitFaqs} data-id="element-16" data-mp="3gkuy3jvs9b9l" /> : <Faq data-id="element-17" data-mp="3gm647qcpav3v" />}
        {isKit ? <FinalCta copy={kitFinalCta} data-id="element-18" data-mp="3glo2wfb6lqp3" /> : <FinalCta data-id="element-19" data-mp="3bmjq7ep1tau0" />}
      </main>
      <Footer data-id="element-20" data-mp="3bncp5thrmw1l" />
      {showPurchaseNotifications && <PurchaseToast data-id="element-21" data-mp="3bkgss9lkgff9" />}
    </div>;
}